import { render, staticRenderFns } from "./BundlePurchaseLayout2.vue?vue&type=template&id=4cdf7930&"
import script from "./BundlePurchaseLayout2.vue?vue&type=script&lang=js&"
export * from "./BundlePurchaseLayout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports